import {
	buildSearchEngine,
	loadFieldActions,
	buildResultsPerPage,
} from "@coveo/headless";
import { getDynamicFieldName } from "drh-js-library/src/community-finder/field-utils/get-dynamic-fieldname";

import DrhCoveoFields from "../../util/maps-enums/DrhCoveoFieldsEnum";

//Initialize the engine
const drhHeadlessEngine = buildSearchEngine({
	configuration: {
		name: "drh-search-box",
		organizationId: process.env.REACT_APP_DRH_COVEO_ORG_ID!,
		accessToken: process.env.REACT_APP_DRH_COVEO_ACCESS_TOKEN!,
		search: {
			pipeline: process.env.REACT_APP_DRH_COVEO_PIPELINE_NAME,
		},
	},
});

//A list of all of the custom fields to include in search results.
const DrhCustomFields = [
	getDynamicFieldName(DrhCoveoFields.AutoComplete.fieldName),
];

//Add the custom DRH fields to the engine
const fieldActions = loadFieldActions(drhHeadlessEngine);
drhHeadlessEngine.dispatch(
	fieldActions.registerFieldsToInclude(DrhCustomFields),
);

//Set the initial number of pages 10 a high number, we will only ever have one page.  The pager on the result list
// is doing client side paging.
buildResultsPerPage(drhHeadlessEngine, {
	initialState: { numberOfResults: 1000 },
});

export { drhHeadlessEngine };
